import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class TicketRefund extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="ticketRefund">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >退票收费规则</NavBar>
                <div className="contentBox">
                    <div className="first">
                        <div className="title">退票收费规则</div>
                        <div> 乘客确认订单后，若行程计划出现变更可申请取消订单或者改签。距离发车时间之前均可申请取消订单，改签将于发车前2小时停止，请乘客按照行程计划合理安排时间。旅客退改签按以下规定计收费用：</div>
                        <div className="rule">取消订单收费标准</div>
                        <div>1.取消订单申请时间距离发车时间超过24小时，不收手续费；</div>
                        <div>2.取消订单申请时间距离发车时间超过12小时但小于24小时，收取订单金额5%作为手续费；</div>
                        <div>3.取消订单申请时间距离发车时间小于12小时，收取订单金额20%作为手续费；</div>
                        <div className="color">4.距离发车时间不足2小时或超过发车时间的订单不可取消。</div>
                        <div className="rule">改签收费标准</div>
                        <div>1.改签申请时间距离发车时间超过24小时，不收取手续费；</div>
                        <div>2.改签申请时间距离发车时间超过12小时但小于24小时，收取订单金额5%作为手续费；</div>
                        <div>3.改签申请时间距离发车时间超过2小时但小于12小时，收取订单金额10%作为手续费；</div>
                        <div>4.距离发车时间不足2小时的不支持改签。</div>
                    </div>
                    <div className="colorRed">温馨提示：网上取消订单不提供取消订单凭证！</div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Member/HelpCenter/ticketRefund/index.js